/* @refresh reload */
import { render } from 'solid-js/web'
import { onMount, onCleanup } from 'solid-js'
import App from './App'
import { actions } from './store/gameStore'
import { SaveSystem } from './systems/SaveSystem'
import { Analytics } from './systems/AnalyticsSystem'
import { BALANCE } from './config/balanceConfig'
import { t } from './i18n'
import './styles.css'

// Initialize and render
render(() => {
  onMount(() => {
    // Load saved game
    const savedData = SaveSystem.load()
    if (savedData) {
      actions.load(savedData)
      console.log(t('consoleGameLoaded'))
    }
    
    // Track game start
    Analytics.gameStart()

    // Game loop
    let lastTick = Date.now()
    let lastSave = Date.now()

    const gameLoop = () => {
      const now = Date.now()
      const deltaSeconds = (now - lastTick) / 1000
      
      actions.tick(deltaSeconds)
      lastTick = now

      // Auto save
      if (now - lastSave >= BALANCE.AUTO_SAVE_INTERVAL) {
        SaveSystem.save(actions.save())
        lastSave = now
        console.log(t('consoleGameSaved'))
      }

      animationId = requestAnimationFrame(gameLoop)
    }

    let animationId = requestAnimationFrame(gameLoop)

    onCleanup(() => {
      cancelAnimationFrame(animationId)
    })
  })

  return <App />
}, document.getElementById('app')!)
